import React, {useState, useEffect} from 'react';
import { Button, FlatList, StyleSheet, TextInput, TouchableOpacity, View } from 'react-native'

import tw from '../../../../styles/tailwind';
import Text from '../../../../components/Text';
import Icon from '../../../../components/IcomoonIcon';
import Header from '../../../../navigation/Header';
import api from '../../../../utils/api';
import { useQuery } from '@tanstack/react-query';


import dayjs from 'dayjs'
import 'dayjs/locale/es'
import GuestPassDetailModal from './GuestPassDetailModal';
dayjs.locale('es')

export function EntryPassRow({ pass, onPress }: { pass: EntryPass, onPress: () => void }) {
  const entryDate = dayjs(pass.data?.entry_date)
  const entryHour = dayjs(pass.data?.entry_time)
  const entryDateLimit = dayjs(pass.data?.entry_date_limit)
  const entryHourLimit = dayjs(pass.data?.entry_time_limit)

  // Caducidad visual (stopgap): un pase vencido por fecha se muestra como "Caducado".
  // one_time: caduca si pasó su fecha de acceso; recurrent: si pasó su fecha límite.
  // TODO(backend): el pase debe traer su estado real (activo/usado/caducado) y salir de "activos".
  const today = dayjs().startOf('day')
  const expired =
    pass.periodicity === 'one_time'
      ? (!!pass.data?.entry_date && entryDate.startOf('day').isBefore(today))
      : (!!pass.data?.entry_date_limit && entryDateLimit.startOf('day').isBefore(today))

  // const days = ['Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa', 'Do']
  const days = ['L', 'M', 'X', 'J', 'V', 'S', 'D']

  function renderDays() {
    return (
      <View style={tw`row gap-x-2`}>
        {
          pass.data?.valid_days?.map((valid, index) =>
            <Text key={index} style={tw.style(`text-gray-400`, valid && `text-secondary font-500`)}>{days[index]}</Text>
          )
        }
      </View>
    )
  }

  return (
    <TouchableOpacity style={tw`row justify-between border-b border-gray-200 px-4 py-2`} onPress={onPress}>
      <View style={tw`row flex-1`}>
        {/* Aca va el icono */}

        <View style={tw`flex-1 pr-3`}>
          <Text style={tw`text-gray-500 font-500`}>{pass.guest_name}</Text>


          {
            pass.periodicity == "recurrent" &&
            <View style={tw`row`}>
              <View style={tw`mr-4`}>{renderDays()}</View>
              {
                expired
                  ? <Text style={tw`text-gray-400`}>Caducado</Text>
                  : <Text style={tw`text-primary`}>Activo</Text>
              }
            </View>
          }

          {
            pass.periodicity == "one_time" &&
            <View style={tw`row`}>
              <Text style={tw`text-gray-400 mr-4`}>{pass.periodicity_str}</Text>
              {/* {
                pass.periodicity == "one_time" &&
                  <Text style={tw`text-gray-400`}> - {entryDate.format('ddd D-MM-YYYY')} {entryHour.format('hh:mm a')}</Text>
              } */}

              {
                expired
                  ? <Text style={tw`text-gray-400`}>Caducado</Text>
                  : <Text style={tw`text-primary`}>Activo</Text>
              }
            </View>
          }
        </View>
      </View>

      <View style={tw``}>
        <Icon name='chevron-right' color={tw.color('secondary')} />
      </View>
    </TouchableOpacity>
  )
}



export default function GuestPassesScreen({navigation, route}) {
  const { communityId, unitFeeId } = route.params
  const [shownGuestPass, setShownGuestPass] = useState(null);

  const { isLoading, error, data, refetch } = useQuery({
    queryKey: ['unit.entry-passes', unitFeeId],
    queryFn: () => api.get(`/communities/${communityId}/units/${unitFeeId}/entry-passes`).then(response => response.data),
  })

  return (
    <View style={tw``}>
      <Header showBackButton style={tw`bg-primary`}>
        <View style={tw``}>
          <Text style={tw`text-lg text-secondary`}>Invitados</Text>
          {
            data &&
              <Text style={tw`text-sm text-white`}>{data.length} llave{data.length > 1 ? 's' : ''} activa{data.length > 1 ? 's' : ''}</Text>
          }
        </View>

      </Header>
      
      {/*  */}
      
      <FlatList
        data={data}
        renderItem={({item}) => 
          <EntryPassRow pass={item} onPress={() => setShownGuestPass(item)} />
        }
      />

      <GuestPassDetailModal
        visible={shownGuestPass}
        guestPass={shownGuestPass}
        community={communityId}
        onRequestClose={() => setShownGuestPass(null)}
      />
    </View>
  );
}
